import React from 'react';
import { Theme, useMediaQuery, Backdrop, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../hooks';
import { MenuStatus } from '../constants/Viewer';
import { setMenuStatus } from '../ducks/viewerSlice';

export const MenuBackdrop: React.FC = () => {
  const dispatch = useAppDispatch();
  const theme = useTheme();

  const menuStatus = useAppSelector((state) => state.viewer.menuStatus);

  const mobileView = useMediaQuery((t: Theme) => t.breakpoints.down('md'));

  return (
    <Backdrop
      open={menuStatus !== MenuStatus.Closed && mobileView}
      sx={{
        zIndex: theme.zIndex.drawer - 1,
      }}
      onClick={() => {
        dispatch(setMenuStatus(MenuStatus.Closed));
      }}
    />
  );
};
